/* compoCASE – moderne Bild-Text-Zeilen: Variante setzen, Einblenden beim Scrollen, Parallaxe (story) */
(function () {
  var root = document.documentElement;
  if (root.getAttribute('data-cc-rows') === '1') return;
  root.setAttribute('data-cc-rows', '1');

  function init() {
    var cfg = document.querySelector('[data-cc-rows-variant]');
    if (!cfg) return;
    var variant = cfg.getAttribute('data-cc-rows-variant') || 'story';

    var secs = document.querySelectorAll('#MainContent > [id*="__multirow_"]');
    if (!secs.length) return;
    Array.prototype.forEach.call(secs, function (s) {
      var m = s.querySelector('.multirow');
      if (m) m.classList.add('cc-rows', 'cc-rows--' + variant);
    });

    /* leere Überschriften (Zeile ohne eigene Überschrift) ausblenden */
    Array.prototype.forEach.call(document.querySelectorAll('.cc-rows .image-with-text__heading'), function (h) {
      if (!h.textContent.trim()) h.classList.add('cc-empty');
    });

    /* Variante kollektion: Fortschrittsbalken unter der Wisch-Galerie */
    if (variant === 'kollektion') {
      Array.prototype.forEach.call(document.querySelectorAll('.cc-rows--kollektion .multirow__inner'), function (inner) {
        var bar = document.createElement('div');
        bar.className = 'cc-rows-progress';
        bar.setAttribute('aria-hidden', 'true');
        bar.appendChild(document.createElement('span'));
        inner.parentNode.insertBefore(bar, inner.nextSibling);
        function prog() {
          var max = inner.scrollWidth - inner.clientWidth;
          var vis = inner.scrollWidth ? inner.clientWidth / inner.scrollWidth : 1;
          var p = max > 0 ? inner.scrollLeft / max : 0;
          bar.style.setProperty('--cc-prog-w', (vis * 100).toFixed(1) + '%');
          bar.style.setProperty('--cc-prog-x', (p * (1 / vis - 1) * 100).toFixed(1) + '%');
        }
        inner.addEventListener('scroll', prog, { passive: true });
        window.addEventListener('resize', prog, { passive: true });
        prog();
      });
    }

    var rows = Array.prototype.slice.call(document.querySelectorAll('.cc-rows .image-with-text'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    root.classList.add('cc-rows-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    rows.forEach(function (r) { io.observe(r); });

    /* Parallaxe nur bei Variante story */
    if (variant !== 'story') return;
    var imgs = rows.map(function (r) { return r.querySelector('.image-with-text__media img'); }).filter(Boolean);
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var reads = imgs.map(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        return (r.top + r.height / 2 - vh / 2);
      });
      imgs.forEach(function (img, i) {
        var y = Math.max(-40, Math.min(40, -reads[i] * 0.06));
        img.style.setProperty('--cc-par', y.toFixed(1) + 'px');
      });
    }
    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
